import { render, staticRenderFns } from "./ProductRecordDetail.vue?vue&type=template&id=38f9a98f&scoped=true"
import script from "./ProductRecordDetail.vue?vue&type=script&lang=js"
export * from "./ProductRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductRecordDetail.vue?vue&type=style&index=0&id=38f9a98f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9a98f",
  null
  
)

export default component.exports